import { render, staticRenderFns } from "./platformRevenue.vue?vue&type=template&id=d545802c&scoped=true&"
import script from "./platformRevenue.vue?vue&type=script&lang=js&"
export * from "./platformRevenue.vue?vue&type=script&lang=js&"
import style0 from "./platformRevenue.vue?vue&type=style&index=0&id=d545802c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d545802c",
  null
  
)

export default component.exports